/**
 * Disable scroll on the page and add padding to the body to prevent page from jumping when scroll is disabled
 * @returns void
 */
export function disableScroll() {
  const scrollBarWidth =
    window.innerWidth - document.documentElement.clientWidth;

  document.body.style.overflow = "hidden";
  document.body.style.paddingRight = `${scrollBarWidth}px`;
}

/**
 * Enable scroll on the page and remove padding from the body
 * @returns void
 */
export function enableScroll() {
  document.body.style.overflow = "";
  document.body.style.paddingRight = "";
}
